
<template>
  <div class="appDashboard dashboard2">
    <div :class="{container:appConfig.container}">
      <app-header :title="title"></app-header>
    </div>
    <v-layout class="flex md12 ml-1" :class="{container:appConfig.container}" row wrap>
      <app-card class="md12 sm12 xs12 d-flex" :obj="{title}">
        <div slot="body">
          <v-layout style="position: absolute; left: 50px;">
            <v-btn
              depressed
              color="primary"
              :class="{disabled: isAutoUpdate}"
              v-on:click="onClickAutoUpdate"
            >
              {{ $t('CurrentStatus.AutoUpdate')}}
              <span v-if="isAutoUpdate">({{countDownTimer}})</span>
            </v-btn>
            <v-btn
              depressed
              color="primary"
              :disabled="!isAutoUpdate"
              v-on:click="onClickStopUpdate"
            >{{ $t('CurrentStatus.StopUpdate')}}</v-btn>

            <v-btn
              depressed
              color="primary"
              :class="{disabled: isAutoUpdate}"
              v-on:click="onClickUpdate"
            >{{ $t('CurrentStatus.ManualUpdate')}}</v-btn>
          </v-layout>
          <v-layout>
            <span v-if="onOffStatus == 'ON-LINE'" class="onStatus">{{onOffStatus}}</span>
            <span v-if="onOffStatus == 'OFF-LINE'" class="offStatus">{{onOffStatus}}</span>
          </v-layout>
          <v-layout style="position: absolute; right: 50px;">
            <v-btn
              depressed
              class="v-btn v-btn--depressed theme--light info"
              v-on:click="onClickNiMH"
              v-if="systemSn == 'PG-KOKURA-200V'"
            >SYSTEM & NiMH STATUS</v-btn>
            <v-btn
              depressed
              class="v-btn v-btn--depressed theme--light info"
              v-on:click="onClickTop"
            >{{ $t('CurrentStatus.GoToTop')}}</v-btn>
          </v-layout>
          <object
            id="svg-fig"
            :data="svgUrl"
            type="image/svg+xml"
            width="100%"
            height="100%"
            style="margin-top: 50px;"
          ></object>
        </div>
      </app-card>
    </v-layout>
  </div>
</template>

<script>
import mediator from "../../components/common/mediator.vue";
import moment from "moment";
import locale from "../../utility/Locale";

export default {
  name: "BankStatus",
  mixins: [mediator],

  mounted() {
    $(".appCard__header").remove();

    this.systemSn = this.$root.currentSerial.system;
    this.title = this.$root.currentPageName;

    this.setSvgUrl();
    setTimeout(() => {
      this.viewSVG();
      // デフォルトで自動更新
      this.onClickAutoUpdate();
    }, this.$root.svgWaitingTime);
  },
  beforeDestroy() {
    clearInterval(this.$root.currentTimer);
  },
  data() {
    const $t = this.$t.bind(this);

    return {
      systemSn: "",
      //title: $t("BankStatus.Item"),
      title: "",
      $fig: null,
      isAutoUpdate: false,
      countDownTimer: 10,
      svgUrl: "",
      onOffStatus: '',
      isBankFirstRequest: true
    };
  },
  methods: {
    onClickUpdate() {
      this.isAutoUpdate = false;
      this.countDownTimer = 10;
      this.viewSVG();
    },
    onClickAutoUpdate() {
      this.isAutoUpdate = true;

      this.$root.currentTimer = setInterval(() => {
        if (!this.isAutoUpdate) {
          clearInterval(this.$root.currentTimer);
        }

        if (this.countDownTimer === 0) {
          this.viewSVG();
          this.countDownTimer = 10;
        } else {
          this.countDownTimer--;
        }
      }, 1000);
    },
    onClickStopUpdate() {
      this.isAutoUpdate = false;
      this.countDownTimer = 10;
    },
    onClickTop() {
      this.$router.push({ name: "top_page" });
    },
    onClickNiMH() {
      this.$router.push({ name: "nimh_status" });
    },
    viewSVG() {
      let vm = this;
      const serialNo = vm.axios
        .get(`${vm.$root.url}/Customer/BankStatus`, {
          headers: {
            Authorization: `Bearer ${vm.$root.token}`
          },
          params: {
            assign: vm.$root.assign,
            systemSn: vm.$root.currentSerial.system
          }
        })
        .then(response => {
          this.$fig = $(document.getElementById("svg-fig").contentDocument);

          let data = response.data;
          if(this.isBankFirstRequest){
            this.isBankFirstRequest = false;
            this.modifyBankSVG(data);
          }

          // BANKがどれか一つでもONLINEならばシステム自体をONLINEにする
          this.onOffStatus = "OFF-LINE";
          for (var i = 0; i < parseInt(data.length); i++) {
            if (data[i] && data[i].onOffStatus == "ON-LINE") {
              this.onOffStatus = "ON-LINE";
            }
          }

          this.setSystemBase(data[0]);
          this.setBankVisible(data);
          this.setBankBase(data);
          this.setErrorCode(data);
          this.setSwitch(data);
          this.setBankImage(data);
          this.setAnimation(data);

          vm.loading = false;
        })
        .catch(error => {
          vm.error = true;
          vm.result = "Error";
          vm.showResult = true;
        });
    },
    setSvgUrl() {
      if (process.env.NODE_ENV === "development") {
        if (locale.getCurrentLanguage() === "ja") {
          this.svgUrl = "/static/svg/bank_jp.svg";
        } else {
          this.svgUrl = "/static/svg/bank_cn.svg";
        }
      } else {
        if (locale.getCurrentLanguage() === "ja") {
          this.svgUrl = "static/svg/bank_jp.svg";
        } else {
          this.svgUrl = "static/svg/bank_cn.svg";
        }
      }
    },
    modifyBankSVG(data) {
      if(data[0].showSoe){
        this.$fig.find(`.bankSoeVisibility`).css('visibility', 'visible');
      }
    },
    setSystemBase(data) {
      let $base_txt_title = this.$fig.find("#base-txt-title");
      $base_txt_title.text(data.systemNm);

      let $base_data_voltage = this.$fig.find("#base-data-voltage");
      $base_data_voltage.text(data.voltageVl + " V");

      let $base_data_current = this.$fig.find("#base-data-current");
      $base_data_current.text(data.systemTotalCurrent + " A");
    },
    // Bankの表示/非表示
    setBankVisible(data) {
      var bankCount = data[0].bankcntVl;
      for (var i = 0; i < bankCount; i++) {
        let $bank = this.$fig.find(`#bank-${data[i].bankNo}`);
        $bank.data("bankSn", data[i].bankSn);

        if (i <= bankCount) {
          $bank.css("display", "inline");
          let pos = 230 * i;
          $bank.attr("transform", "translate(0," + pos + ")");
        } else {
          $bank.css("display", "none");
        }

        $bank.off("click");
        if ((this.$root.userRole).at(-1) > 1) {
          $bank.on("click", event => {
            this.$root.currentSerial.bank = $(event.currentTarget).data('bankSn');
            this.$router.push({ name: "rack_status" });
          });
        }
      }

      if ((this.$root.userRole).at(-1) == 1) {
        // Do not use the finger pointer
        this.$fig.find(`.st87`).css('cursor', 'default');
      };

      let $base_current = this.$fig.find("#base-current-img");
      let $current_line_length = 230 + 230 * (bankCount - 1) + 80;
      $base_current.css("display", "inherit");
      if (bankCount == 0) {
        $base_current.attr("y1", 230);
      } else {
        $base_current.attr("y1", $current_line_length);
      }
    },
    setBankBase(data) {
      data.map((bank) => {
        //PSC
        let $pcs_val = this.$fig.find(`#bank-txt-pcs-${bank.bankNo}`);
        if (bank.bankNo != undefined && bank.bankNo != null) {
          $pcs_val.text('PCS-' + bank.bankNo);
        }

        // BANK名
        let $bankname = this.$fig.find(`#bank-txt-name-${bank.bankNo}`);
        if (bank.bankNo != undefined && bank.bankNo != null) {
          $bankname.text('BANK_' + bank.bankNo);
        }

        // BANKSn
        let $bankSn = this.$fig.find(`#bank-txt-no-${bank.bankNo}`);
        if (bank.bankSn != undefined && bank.bankSn != null) {
          $bankSn.text(bank.bankSn);
        }

        let $totalCurrent = this.$fig.find(`#bank-data-current-${bank.bankNo}`);
        if (bank.totalCurrent != undefined && bank.totalCurrent != null) {
          $totalCurrent.text(`${bank.totalCurrent} A`);
        }

        let $voltageVl = this.$fig.find(`#bank-data-volt-${bank.bankNo}`);
        if (bank.totalVolt != undefined && bank.totalVolt != null) {
          $voltageVl.text(`${bank.totalVolt} V`);
        }

        let $capacity = this.$fig.find(`#bank-data-left-${bank.bankNo}`);
        if (bank.capacity != undefined && bank.capacity != null) {
          $capacity.text(`${Math.round(bank.capacity * (bank.soh/100) * (bank.soc/100))} Ah`);
        }

        let $soc = this.$fig.find(`#bank-data-soc-${bank.bankNo}`);
        if (bank.soc != undefined && bank.soc != null) {
          $soc.text(`${bank.soc} %`);
        }

        let $soe = this.$fig.find(`#bank-data-soe-${bank.bankNo}`);
        if (bank.soh != undefined && bank.soh != null) {
          $soe.text(`${bank.soh} %`);
        }

        let $maxCellVolt = this.$fig.find(`#bank-data-cell-high-${bank.bankNo}`);
        if (bank.maxCellVolt != undefined && bank.maxCellVolt != null) {
          $maxCellVolt.text(`${bank.maxCellVolt} V`);
        }

        let $minCellVolt = this.$fig.find(`#bank-data-cell-low-${bank.bankNo}`);
        if (bank.minCellVolt != undefined && bank.minCellVolt != null) {
          $minCellVolt.text(`${bank.minCellVolt} V`);
        }

        let $maxTemperature = this.$fig.find(`#bank-data-temp-high-${bank.bankNo}`);
        if (bank.maxTemperature != undefined && bank.maxTemperature != null) {
          $maxTemperature.text(`${bank.maxTemperature} ℃`);
        }

        let $minTemperature = this.$fig.find(`#bank-data-temp-low-${bank.bankNo}`);
        if (bank.minTemperature != undefined && bank.minTemperature != null) {
          $minTemperature.text(`${bank.minTemperature} ℃`);
        }

        let $maxVoltRack = this.$fig.find(`#bank-data-cell-high-rack-${bank.bankNo}`);
        if (bank.maxVoltRack != undefined && bank.maxVoltRack != null) {
          $maxVoltRack.text(`Rack ${bank.maxVoltRack}`);
        }

        let $minVoltRack = this.$fig.find(`#bank-data-cell-low-rack-${bank.bankNo}`);
        if (bank.minVoltRack != undefined && bank.minVoltRack != null) {
          $minVoltRack.text(`Rack ${bank.minVoltRack}`);
        }

        let $maxTemperatureRack = this.$fig.find(`#bank-data-temp-high-rack-${bank.bankNo}`);
        if (bank.maxTemperatureRack != undefined && bank.maxTemperatureRack != null) {
          $maxTemperatureRack.text(`Rack ${bank.maxTemperatureRack}`);
        }

        let $minTemperatureRack = this.$fig.find(`#bank-data-temp-low-rack-${bank.bankNo}`);
        if (bank.minTemperatureRack != undefined && bank.minTemperatureRack != null) {
          $minTemperatureRack.text(`Rack ${bank.minTemperatureRack}`);
        }
      });
    },
    setSwitch(data) {
      data.map(bank => {
        let $switch_off_val = this.$fig.find(`#bank-switch-off-${bank.bankNo}`);
        let $switch_on_val = this.$fig.find(`#bank-switch-on-${bank.bankNo}`);
        if (bank.switchOnOff == 1) {
          $switch_on_val.css("display", "inline");
          $switch_off_val.css("display", "none");
        } else {
          $switch_on_val.css("display", "none");
          $switch_off_val.css("display", "inline");
        }
      });
    },
    setBankImage(data) {
      data.map(bank => {
        let barwidth = (615 * bank.soc) / 100;
        let positiony = 388;

        let $bank_scale_red = this.$fig.find(`#bank-scale-red-${bank.bankNo}`);
        let $bank_scale_yellow = this.$fig.find(
          `#bank-scale-yellow-${bank.bankNo}`
        );
        let $bank_scale_green = this.$fig.find(
          `#bank-scale-green-${bank.bankNo}`
        );
        let $bank_scale_error = this.$fig.find(
          `#bank-scale-error-${bank.bankNo}`
        );

        let allError = false;
        const alarm = Array.from(bank.alarm).reverse();
        alarm.map((error, index) => {
          if (error === "1") {
            allError = true;
          }
        });

        if (allError) {
          $bank_scale_error.css("display", "inherit");
          $bank_scale_error.css("width", barwidth);
          $bank_scale_red.css("display", "none");
          $bank_scale_yellow.css("display", "none");
          $bank_scale_green.css("display", "none");
        } else {
          if (bank.soc <= 20) {
            $bank_scale_red.css("display", "inherit");
            $bank_scale_red.css("width", barwidth);
            $bank_scale_yellow.css("display", "none");
            $bank_scale_green.css("display", "none");
            $bank_scale_error.css("display", "none");
          } else if (bank.soc <= 50) {
            $bank_scale_red.css("display", "none");
            $bank_scale_yellow.css("display", "inherit");
            $bank_scale_yellow.css("width", barwidth);
            $bank_scale_green.css("display", "none");
            $bank_scale_error.css("display", "none");
          } else {
            $bank_scale_red.css("display", "none");
            $bank_scale_yellow.css("display", "none");
            $bank_scale_green.css("display", "inherit");
            $bank_scale_green.css("width", barwidth);
            $bank_scale_error.css("display", "none");
          }
        }
      });
    },
    setErrorCode(data) {
      data.map(bank => {
        const alarm = Array.from(bank.alarm).reverse();
        alarm.map((error, index) => {
          let $error_f_val = null;
          let $error_txt = null;
          switch (index) {
            case 0: // OVP
              $error_f_val = this.$fig.find(`#bg-ovp-f-${bank.bankNo}`);
              $error_txt = this.$fig.find(`#txt-ovp-${bank.bankNo}`);
              break;
            case 1: // UVP
              $error_f_val = this.$fig.find(`#bg-uvp-f-${bank.bankNo}`);
              $error_txt = this.$fig.find(`#txt-uvp-${bank.bankNo}`);
              break;
            case 2: // OCP
              $error_f_val = this.$fig.find(`#bg-ocp-f-${bank.bankNo}`);
              $error_txt = this.$fig.find(`#txt-ocp-${bank.bankNo}`);
              break;
            case 3: // UCP
              $error_f_val = this.$fig.find(`#bg-ucp-f-${bank.bankNo}`);
              $error_txt = this.$fig.find(`#txt-ucp-${bank.bankNo}`);
              break;
            case 4: // OTP
              $error_f_val = this.$fig.find(`#bg-otp-f-${bank.bankNo}`);
              $error_txt = this.$fig.find(`#txt-otp-${bank.bankNo}`);
              break;
            case 5: // UTP
              $error_f_val = this.$fig.find(`#bg-utp-f-${bank.bankNo}`);
              $error_txt = this.$fig.find(`#txt-utp-${bank.bankNo}`);
              break;
          }

          if (error === "1") {
            if ($error_f_val) {
              $error_f_val.css("display", "inherit");
              $error_f_val.css("fill", "#ff3121");
              $error_txt.css("fill", "#ffffff");
            }
          } else {
            if ($error_f_val) {
              $error_f_val.css("display", "none");
              $error_txt.css("fill", "#727272");
            }
          }
        });
      });
    },
    setAnimation(data) {
      data.map((bank) => {
        //animation anime switch
        let $anime_switch_in = this.$fig.find(`#bank-switch-anime-in-${bank.bankNo}`);
        let $anime_switch_out = this.$fig.find(`#bank-switch-anime-out-${bank.bankNo}`);
        let $anime_switch_neutral = this.$fig.find(`#bank-switch-neutral-${bank.bankNo}`);
        if (bank.totalCurrent > 0) {
          $anime_switch_in.css('display', 'none');
          $anime_switch_out.css('display', 'inherit');
          $anime_switch_neutral.css('display', 'none');
        } else if (bank.totalCurrent < 0) {
          $anime_switch_in.css('display', 'inherit');
          $anime_switch_out.css('display', 'none');
          $anime_switch_neutral.css('display', 'none');
        } else {
          $anime_switch_in.css('display', 'none');
          $anime_switch_out.css('display', 'none');
          $anime_switch_neutral.css('display', 'inherit');
        }
      });

      //animation tate
      let $current_line_01_down = this.$fig.find('#anime-line-down-01');
      let $current_line_01_up = this.$fig.find('#anime-line-up-01');
      let $current_line_02_down = this.$fig.find('#anime-line-down-02');
      let $current_line_02_up = this.$fig.find('#anime-line-up-02');
      let $current_line_03_down = this.$fig.find('#anime-line-down-03');
      let $current_line_03_up = this.$fig.find('#anime-line-up-03');
      let $current_line_04_down = this.$fig.find('#anime-line-down-04');
      let $current_line_04_up = this.$fig.find('#anime-line-up-04');
      let $current_line_05_down = this.$fig.find('#anime-line-down-05');
      let $current_line_05_up = this.$fig.find('#anime-line-up-05');
      let $current_line_06_down = this.$fig.find('#anime-line-down-06');
      let $current_line_06_up = this.$fig.find('#anime-line-up-06');
      let $current_line_07_down = this.$fig.find('#anime-line-down-07');
      let $current_line_07_up = this.$fig.find('#anime-line-up-07');
      let $current_line_08_down = this.$fig.find('#anime-line-down-08');
      let $current_line_08_up = this.$fig.find('#anime-line-up-08');
      let $current_line_09_down = this.$fig.find('#anime-line-down-09');
      let $current_line_09_up = this.$fig.find('#anime-line-up-09');
      let $current_line_10_down = this.$fig.find('#anime-line-down-10');
      let $current_line_10_up = this.$fig.find('#anime-line-up-10');

      // if文の判定時に、存在しない変数が含まれるとエラーが起きるので修正
      // 「parseInt」から「parseFloat」へ変更
      // 「parseInt」だと整数値になってしまうので、０から１までの小数値が０になってしまいアニメーションがおかしくなる

      let sum_10 = 0;
      if (data[9] && data[9].switchOnOff == 1) {
        sum_10 = parseFloat(data[9].totalCurrent);
      } else {
        sum_10 = 0;
      }

      let sum_10_09 = 0;
      if (data[8] && data[8].switchOnOff == 1) {
        sum_10_09 = sum_10 + parseFloat(data[8].totalCurrent);
      } else {
        sum_10_09 = sum_10;
      }

      let sum_10_08 = 0;
      if (data[7] && data[7].switchOnOff == 1) {
        sum_10_08 = sum_10_09 + parseFloat(data[7].totalCurrent);
      } else {
        sum_10_08 = sum_10_09;
      }

      let sum_10_07 = 0;
      if (data[6] && data[6].switchOnOff == 1) {
        sum_10_07 = sum_10_08 + parseFloat(data[6].totalCurrent);
      } else {
        sum_10_07 = sum_10_08;
      }

      let sum_10_06 = 0;
      if (data[5] && data[5].switchOnOff == 1) {
        sum_10_06 = sum_10_07 + parseFloat(data[5].totalCurrent);
      } else {
        sum_10_06 = sum_10_07;
      }

      let sum_10_05 = 0;
      if (data[4] && data[4].switchOnOff == 1) {
        sum_10_05 = sum_10_06 + parseFloat(data[4].totalCurrent);
      } else {
        sum_10_05 = sum_10_06;
      }

      let sum_10_04 = 0;
      if (data[3] && data[3].switchOnOff == 1) {
        sum_10_04 = sum_10_05 + parseFloat(data[3].totalCurrent);
      } else {
        sum_10_04 = sum_10_05;
      }

      let sum_10_03 = 0;
      if (data[2] && data[2].switchOnOff == 1) {
        sum_10_03 = sum_10_04 + parseFloat(data[2].totalCurrent);
      } else {
        sum_10_03 = sum_10_04;
      }

      let sum_10_02 = 0;
      if (data[1] && data[1].switchOnOff == 1) {
        sum_10_02 = sum_10_03 + parseFloat(data[1].totalCurrent);
      } else {
        sum_10_02 = sum_10_03;
      }

      // 全てのBankのリレーが切れていたら、PCS直下の電流のアニメーションが出ないようにする
      if (data[0].systemTotalCurrent > 0 && (sum_10_02 != 0 || data[0].switchOnOff == 1)) {
        $current_line_01_down.css('display', 'none');
        $current_line_01_up.css('display', 'inherit');
      } else if (data[0].systemTotalCurrent < 0 && (sum_10_02 != 0 || data[0].switchOnOff == 1)) {
        $current_line_01_down.css('display', 'inherit');
        $current_line_01_up.css('display', 'none');
      } else {
        $current_line_01_down.css('display', 'none');
        $current_line_01_up.css('display', 'none');
      }

      let BankCntVl = data[0].bankcntVl;

      if (BankCntVl >= 10) {
        if (sum_10 > 0) {
          $current_line_10_down.css('display', 'none');
          $current_line_10_up.css('display', 'inherit');
        } else if (sum_10 < 0) {
          $current_line_10_down.css('display', 'inherit');
          $current_line_10_up.css('display', 'none');
        } else {
          $current_line_10_down.css('display', 'none');
          $current_line_10_up.css('display', 'none');
        }
      }
      if (BankCntVl >= 9) {
        if (sum_10_09 > 0) {
          $current_line_09_down.css('display', 'none');
          $current_line_09_up.css('display', 'inherit');
        } else if (sum_10_09 < 0) {
          $current_line_09_down.css('display', 'inherit');
          $current_line_09_up.css('display', 'none');
        } else {
          $current_line_09_down.css('display', 'none');
          $current_line_09_up.css('display', 'none');
        }
      }
      if (BankCntVl >= 8) {
        if (sum_10_08 > 0) {
          $current_line_08_down.css('display', 'none');
          $current_line_08_up.css('display', 'inherit');
        } else if (sum_10_08 < 0) {
          $current_line_08_down.css('display', 'inherit');
          $current_line_08_up.css('display', 'none');
        } else {
          $current_line_08_down.css('display', 'none');
          $current_line_08_up.css('display', 'none');
        }
      }
      if (BankCntVl >= 7) {
        if (sum_10_07 > 0) {
          $current_line_07_down.css('display', 'none');
          $current_line_07_up.css('display', 'inherit');
        } else if (sum_10_07 < 0) {
          $current_line_07_down.css('display', 'inherit');
          $current_line_07_up.css('display', 'none');
        } else {
          $current_line_07_down.css('display', 'none');
          $current_line_07_up.css('display', 'none');
        }
      }
      if (BankCntVl >= 6) {
        if (sum_10_06 > 0) {
          $current_line_06_down.css('display', 'none');
          $current_line_06_up.css('display', 'inherit');
        } else if (sum_10_06 < 0) {
          $current_line_06_down.css('display', 'inherit');
          $current_line_06_up.css('display', 'none');
        } else {
          $current_line_06_down.css('display', 'none');
          $current_line_06_up.css('display', 'none');
        }
      }
      if (BankCntVl >= 5) {
        if (sum_10_05 > 0) {
          $current_line_05_down.css('display', 'none');
          $current_line_05_up.css('display', 'inherit');
        } else if (sum_10_05 < 0) {
          $current_line_05_down.css('display', 'inherit');
          $current_line_05_up.css('display', 'none');
        } else {
          $current_line_05_down.css('display', 'none');
          $current_line_05_up.css('display', 'none');
        }
      }
      if (BankCntVl >= 4) {
        if (sum_10_04 > 0) {
          $current_line_04_down.css('display', 'none');
          $current_line_04_up.css('display', 'inherit');
        } else if (sum_10_04 < 0) {
          $current_line_04_down.css('display', 'inherit');
          $current_line_04_up.css('display', 'none');
        } else {
          $current_line_04_down.css('display', 'none');
          $current_line_04_up.css('display', 'none');
        }
      }
      if (BankCntVl >= 3) {
        if (sum_10_03 > 0) {
          $current_line_03_down.css('display', 'none');
          $current_line_03_up.css('display', 'inherit');
        } else if (sum_10_03 < 0) {
          $current_line_03_down.css('display', 'inherit');
          $current_line_03_up.css('display', 'none');
        } else {
          $current_line_03_down.css('display', 'none');
          $current_line_03_up.css('display', 'none');
        }
      }
      if (BankCntVl >= 2) {
        if (sum_10_02 > 0) {
          $current_line_02_down.css('display', 'none');
          $current_line_02_up.css('display', 'inherit');
        } else if (sum_10_02 < 0) {
          $current_line_02_down.css('display', 'inherit');
          $current_line_02_up.css('display', 'none');
        } else {
          $current_line_02_down.css('display', 'none');
          $current_line_02_up.css('display', 'none');
        }
      }

    }
  }
};
</script>

<style>
.dashboard2 {
  z-index: 9;
}

.dashboard2 .offset-sm3 {
  margin: 0 !important;
  flex-basis: 100% !important;
  max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/router/Customer/BankStatus.vue